import React, { ReactElement } from 'react'

import styled from 'styled-components'

import { i18n } from '../../approval-settings/utils/utils'

interface ModalFieldProps {
    id?: string
    label?: string
    field: ReactElement
    requiredField?: boolean
    style?: object
}

export const ModalField = ({ id, label, field, requiredField, style }: ModalFieldProps): ReactElement => {
    return (
        <StyledModalField style={style}>
            {label && (
                <div className="modal-field-label">
                    <strong>{i18n(label)}</strong>
                    {requiredField ? <span>*</span> : ''}
                </div>
            )}
            {field}
            {id}
        </StyledModalField>
    )
}

export const StyledModalField = styled.div`
    .modal-field-label {
        display: flex;
        gap: 4px;

        margin-bottom: 8px;

        strong,
        span {
            font-size: 13px;
        }

        span {
            color: var(--red-700);
        }
    }

    span {
        font-size: 13px !important;
        font-weight: 400 !important;
    }

    .form-group {
        margin-bottom: 0;

        .Select.is-open > .Select-control .Select-arrow {
            border-color: transparent transparent var(--blue-500);
        }

        .Select.is-open > .Select-control .Select-arrow::before {
            content: ' ';
            position: absolute;
            top: -7px;
            left: -15px;
            width: 1px;
            height: 20px;

            background-color: var(--gray-500);
        }

        .Select-placeholder {
            color: var(--gray-700) !important;
        }

        .Select div {
            color: var(--gray-800);
        }

        .Select-control {
            width: 266px;
            border-radius: 3px;

            .Select-clear {
                margin-right: 13px;
            }

            .Select-arrow {
                position: relative;
                border-color: var(--blue-500) transparent transparent;
            }

            .Select-arrow::before {
                content: ' ';
                position: absolute;
                top: -12px;
                left: -15px;
                width: 1px;
                height: 20px;

                background-color: var(--gray-500);
            }
        }
    }
`
